import React, { ComponentProps, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { flex } from 'styled-system';

const StyledBody = styled(Box)`
  ${flex};
  overflow-y: auto;
`;

interface BodyProps extends ComponentProps<typeof Box> {
  children: ReactNode;
}

const Body = ({ children, ...props }: BodyProps) => (
  <StyledBody flex="1" maxHeight={['100%', null, '760px']} {...props}>
    {children}
  </StyledBody>
);

export default Body;
